<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-8">
<h1>9</h1>
<p>No word comes through from Sammy Payne so I go see Mary.</p>
<p>“I’m making dinner. Want some?” She’s in reasonable spirits.</p>
<p>“If it’s no bother.”</p>
<p>“It’s no bother.” As we sit and eat, she says, “How’s it goin’?”</p>
<p>“Not so bad,” I tell her. “Did Steven have a computer, phone, or diary?”</p>
<p>“No computer, and I didn’t come across a diary. I packed away all his belongings. His phone stayed here when they took him.”</p>
<p>“The girl Steven took to the cinema a couple of times. Is there anything more you can tell me about her?”</p>
<p>“He never told me her name. You think she’s part of Steven being taken?”</p>
<p>“Might be. It’s possible she was helping Steven, or she was keeping tabs on him for those not wanting him to find the truth about his father. She could be helpful.”</p>
<p>“She might know where Steven is?”</p>
<p>“I wouldn’t get my hopes up.”</p>
<p>“How’re you goin’ to find her with nothin’ to go on.”</p>
<p>“Maybe his phone would help. If you don’t mind, I’ll have a look at his room before I go. Did Steven have any particular friend or friends?”</p>
<p>“One good friend, Stanley Ross. Started in Rix and McBeath’s Joinery Works as apprentices together. Steven and him had dreams of ownin’ their own firm. Firm kept them both on after they came out of their time.”</p>
<p>“No-one else?”</p>
<p>“Not that I know of. More stew.”</p>
<p>“If you can spare it. This is good stew.”</p>
<p>“I make a pot full. There’s plenty. Does a couple of days. Another soda farl?”</p>
<p>“Maybe a half, thanks. Bake it yourself?”</p>
<p>“I did.”</p>
<p>I’m eating my second helping, when I get ‘Homecoming’.</p>
<p>“Hallo Ima. I’m working.” I put it on speaker.</p>
<p>“My son is working, he says. He hasn’t time to talk to his Ima who has come out and is using this new phone he sent with the <em>B’rit Hadashah</em> on it so that his father, good Jew though he is, won’t know that his wife is doing her best to understand why her son, has taken to follow a man who died 2000 years ago.”</p>
<p>“Ima, enough already. I only said I’m working. I didn’t say I wouldn’t take the time to talk with you.”</p>
<p>“What are you doing?”</p>
<p>“Eating pork stew.”</p>
<p>“Oy vey, I won’t let your father know.”</p>
<p>“Make no difference, he already thinks I’m a schlemiel.”</p>
<p>“No son of mine is a schlemiel. It would make a difference to me. What I’d have to listen to for the next week, maybe forever!” Better he should not know. “Where are you eating this unmentionable stew, and with whom?”</p>
<p>“I’m with Mary, her stew is good.”</p>
<p>“This Mary is young?”</p>
<p>I gesture to Mary, she says:</p>
<p>“I’m eighty-two Mrs Eigerman, and Stanley is very helpful. He’s going to find my son.”</p>
<p>“Not only is he charging you for his services, but you are feeding him as well.”</p>
<p>“Stanley bought me a dinner in a hotel…”</p>
<p>“Oy-oy-oy! I should have a son like that. What did you give him with that unmentionable stew?”</p>
<p>“Soda bread.”</p>
<p>“Of your own baking?”</p>
<p>“Yes.”</p>
<p>“I must have this recipe. What flour do you…”</p>
<p>“Ima, did you phone about anything in particular?”</p>
<p>“Why interrupt your Ima when she is about to get useful information?”</p>
<p>“What was it you phoned about, Ima?”</p>
<p>“It’s your Poppa, he’s giving me a hard time over your sister’s wedding. Not only does he not want to go if you’re going, but now he does not want her to marry this atheist, even if he is a Jewish atheist.”</p>
<p>“What does this Jewish atheist do for a living?”</p>
<p>“For a living he is a doctor who hates the sight of blood.”</p>
<p>“Ah-ha, a Psychiatrist.”</p>
<p>“A Freudnik. He’s been arguing with your father on the basis of some book called <em>Moses and Monotheism</em>. He tells your father that Moses was not a Jew, he was an Egyptian. What I’ve got to listen to after that! Put Mary on again.”</p>
<p>“Mary is on.”</p>
<p>“Mary, I’m Esther. Would it be out of the question if we were to meet somewhere for coffee and exchange recipes? Have you ever baked bagels?”</p>
<p>“No, Esther, but certainly we can meet. Stanley will give you my number, and give me yours. We can arrange a date.”</p>
<p>“Good, good. Keep Stanley away from junk food in the meantime. Good bye Mary, it’s nice to talk.”</p>
<p>“Ima…” Ima disconnects.</p>
<p>“I look forward to meeting your mother.”</p>
<p>“No doubt she is looking forward to meeting you, she needs a break from my father.”</p>
<p>“Have you trouble with your father?”</p>
<p>“Abba has trouble with Yeshua of Nazareth.”</p>
<p>“Why?”</p>
<p>“Because I believe in Yeshua, Adonai’s chosen one.”</p>
<p>“Then you’re a Christian.”</p>
<p>“Those who are Gentiles and believe that Jesus is God’s Messiah are Messianic Gentiles. I’m a Jew, therefore a Messianic Jew. Not that it matters. With Adonai there is neither Jew nor Gentile, just believers in Adonai’s Son, Yeshua.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch013.vue?6a8b7c60